exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color1{color:#673ab7}.color2{color:#2196f3}.color3{color:#ff9800}.bgcolor1{background:#673ab7}.bgcolor2{background:#2196f3}.bgcolor3{background:#ff9800}.progress-label{width:100%;font-size:24px}.progress-score{float:right}.progress-label-lg{font-size:32px}.score-card{padding:12px}", ""]);

// exports
